import { render, staticRenderFns } from "./CreateGroupModal.vue?vue&type=template&id=31835ecc&scoped=true&"
import script from "./CreateGroupModal.vue?vue&type=script&lang=js&"
export * from "./CreateGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateGroupModal.vue?vue&type=style&index=0&id=31835ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31835ecc",
  null
  
)

export default component.exports